import { useEffect } from 'react';

/**
 * Update <title> and <meta name="description"> for the current route.
 * Also updates the canonical link so Google indexes clean per-route URLs.
 * Static OG tags (for social scrapers) stay in public/index.html because
 * FB / X / LinkedIn crawlers do NOT execute JavaScript.
 */
export const useSEO = ({ title, description, path = '' } = {}) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://noaxmedia.com${path}`);
  }, [title, description, path]);
};
